


import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './ExamPage.css';
import { useLocation, useNavigate } from 'react-router-dom';

const PracticeExam  = () => {
  const location = useLocation();
  const studentId = location.state?.studentid;
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [timeLeft, setTimeLeft] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const navigate =useNavigate()
  const EXAM_DURATION = 60 * 60 * 1000; // 1 hour in ms
  const userId = studentId;
  const STORAGE_KEY_TIME = `exam_start_time_${userId}`;
  const STORAGE_KEY_INDEX = `current_index_${userId}`;

  // Fetch questions and current index
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API}/questions/getpraticeexamquestions/${userId}`)
      .then(res => {
        setQuestions(res.data);
        console.log(res.data)
        // Get saved index from localStorage
        const savedIndex = parseInt(localStorage.getItem(STORAGE_KEY_INDEX), 10);
        if (!isNaN(savedIndex) && savedIndex < res.data.length) {
          setCurrentIndex(savedIndex);
        } else {
          setCurrentIndex(0);
        }
      })
      .catch(err => console.error(err));
  }, [userId]);

  // Timer logic
  useEffect(() => {
    let startTime = localStorage.getItem(STORAGE_KEY_TIME);
    if (!startTime) {
      startTime = Date.now();
      localStorage.setItem(STORAGE_KEY_TIME, startTime);
    } else {
      startTime = parseInt(startTime);
    }

    const interval = setInterval(() => {
      const now = Date.now();
      const diff = EXAM_DURATION - (now - startTime);
      if (diff <= 0 && !submitted) {
        clearInterval(interval);
        setTimeLeft(0);
        handleSubmit(); // auto-submit
      } else {
        setTimeLeft(Math.floor(diff / 1000));
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [submitted]);

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60).toString().padStart(2, '0');
    const sec = (seconds % 60).toString().padStart(2, '0');
    return `${min}:${sec}`;
  };

  const handleOptionChange = (questionId, selectedOption) => {
    setAnswers(prev => ({ ...prev, [questionId]: selectedOption }));
  };

  const saveAnswerToDB = async (questionId, selectedOption) => {
    try {
      await axios.post(`${process.env.REACT_APP_API}/questions/save-praticeanswer`, {
        studentId: userId,
        questionId,
        selectedOption,
      });
    } catch (err) {
      console.error('Error saving answer:', err);
    }
  };

  const handleNext = async () => {
    const question = questions[currentIndex];
    const selectedOption = answers[question.id];
    if (selectedOption) {
      await saveAnswerToDB(question.id, selectedOption);
    }

    if (currentIndex < questions.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      localStorage.setItem(STORAGE_KEY_INDEX, newIndex);
    }
  };

  const handleSubmit = async () => {
    setSubmitted(true);
    localStorage.removeItem(STORAGE_KEY_TIME);
    localStorage.removeItem(STORAGE_KEY_INDEX);
       const question = questions[currentIndex];
    const selectedOption = answers[question.id];
    try {
      // for (const [questionId, selectedOption] of Object.entries(answers)) {
        // await saveAnswerToDB(parseInt(questionId), selectedOption);
         await saveAnswerToDB(question.id, selectedOption);
      // }
       const response = await axios.post(`${process.env.REACT_APP_API}/questions/submit-praticeexam`, {
       studentId: userId,
       markCompleted: true,


      });

      alert(`Exam submitted. Your score is ${response.data.score}`);
        //  alert(`Exam submitted`);
         navigate('/profile')
    } catch (error) {
      console.error(error);
      alert('Failed to submit exam.');
    }
  };

  if (questions.length === 0) {
    return <p style={{ textAlign: 'center', marginTop: '50px' }}>Loading questions...</p>;
  }

  const currentQuestion = questions[currentIndex];
  const selectedAnswer = answers[currentQuestion.id];
const correctAnswer = currentQuestion.correct_option;
  return (
    <div className="exam-container">
      <div className="exam-header">
        <h2>Online Exam</h2>
        <h3 className={`timer ${timeLeft <= 60 ? 'warning' : ''}`}>
          Time Left: {formatTime(timeLeft)}
        </h3>
      </div>

      <p className="question-number">
        Question {currentIndex + 1} of {questions.length}
      </p>

       <div>
        <h4 className="question-text">{currentQuestion.question}</h4>
        {['option_a', 'option_b', 'option_c', 'option_d'].map(opt => {
          const isSelected = selectedAnswer === opt;
          let className = 'option-label';

          if (isSelected && selectedAnswer === correctAnswer) {
            className += ' correct';
          } else if (isSelected && selectedAnswer !== correctAnswer) {
            className += ' incorrect';
          }

          return (
            <label key={opt} className={className}>
              <input
                type="radio"
                name={`q${currentQuestion.id}`}
                value={opt}
                checked={isSelected}
                onChange={() =>
                  handleOptionChange(currentQuestion.id, opt, correctAnswer)
                }
                style={{ marginRight: '10px' }}
              />
              {currentQuestion[opt]}
            </label>
          );
        })}
      </div>


      <div className="nav-buttons">
        {currentIndex === questions.length - 1 ? (
          <button
            className="btn btn-submit"
            onClick={handleSubmit}
            disabled={submitted || !selectedAnswer}
          >
            Submit Exam
          </button>
        ) : (
          <button
            className="btn btn-next"
            onClick={handleNext}
            disabled={!selectedAnswer}
          >
            Next
          </button>
        )}
      </div>
    </div>
  );
};

export default PracticeExam ;


// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import './ExamPage.css';
// import { useLocation, useNavigate } from 'react-router-dom';

// const PracticeExam = () => {
//   const location = useLocation();
//   const studentId = location.state?.studentid;
//   const [questions, setQuestions] = useState([]);
//   const [answers, setAnswers] = useState({});
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [submitted, setSubmitted] = useState(false);
//   const navigate = useNavigate();
//   const userId = studentId;

//   useEffect(() => {
//     axios
//       .get(`${process.env.REACT_APP_API}/questions/getpraticeexamquestions/${userId}`)
//       .then(res => {
//         setQuestions(res.data);
//         setCurrentIndex(0);
//       })
//       .catch(err => console.error(err));
//   }, [userId]);

//   const handleOptionChange = async (questionId, selectedOption, correctOption) => {
//     setAnswers(prev => ({
//       ...prev,
//       [questionId]: selectedOption
//     }));

//     try {
//       await axios.post(`${process.env.REACT_APP_API}/questions/save-praticeanswer`, {
//         studentId: userId,
//         questionId,
//         selectedOption,
//       });
//     } catch (err) {
//       console.error('Error saving answer:', err);
//     }
//   };

//   const handleNext = () => {
//     if (currentIndex < questions.length - 1) {
//       setCurrentIndex(currentIndex + 1);
//     }
//   };

//   const handleSubmit = async () => {
//     setSubmitted(true);
//     try {
//       for (const [questionId, selectedOption] of Object.entries(answers)) {
//         await axios.post(`${process.env.REACT_APP_API}/questions/save-praticeanswer`, {
//           studentId: userId,
//           questionId,
//           selectedOption,
//         });
//       }

//       await axios.post(`${process.env.REACT_APP_API}/questions/submit-praticeexam`, {
//         studentId: userId,
//         markCompleted: true,
//       });

//       alert(`Exam submitted`);
//       navigate('/profile');
//     } catch (error) {
//       console.error(error);
//       alert('Failed to submit exam.');
//     }
//   };

//   if (questions.length === 0) {
//     return <p style={{ textAlign: 'center', marginTop: '50px' }}>Loading questions...</p>;
//   }

//   const currentQuestion = questions[currentIndex];
//   const selectedAnswer = answers[currentQuestion.id];
//   const correctAnswer = currentQuestion.correct_option;

//   return (
//     <div className="exam-container">
//       <div className="exam-header">
//         <h2>Practice Exam</h2>
//       </div>

//       <p className="question-number">
//         Question {currentIndex + 1} of {questions.length}
//       </p>

//       <div>
//         <h4 className="question-text">{currentQuestion.question}</h4>
//         {['option_a', 'option_b', 'option_c', 'option_d'].map(opt => {
//           const isSelected = selectedAnswer === opt;
//           let className = 'option-label';

//           if (isSelected && selectedAnswer === correctAnswer) {
//             className += ' correct';
//           } else if (isSelected && selectedAnswer !== correctAnswer) {
//             className += ' incorrect';
//           }

//           return (
//             <label key={opt} className={className}>
//               <input
//                 type="radio"
//                 name={`q${currentQuestion.id}`}
//                 value={opt}
//                 checked={isSelected}
//                 onChange={() =>
//                   handleOptionChange(currentQuestion.id, opt, correctAnswer)
//                 }
//                 style={{ marginRight: '10px' }}
//               />
//               {currentQuestion[opt]}
//             </label>
//           );
//         })}
//       </div>

//       <div className="nav-buttons">
//         {currentIndex === questions.length - 1 ? (
//           <button
//             className="btn btn-submit"
//             onClick={handleSubmit}
//             disabled={!selectedAnswer}
//           >
//             Submit Exam
//           </button>
//         ) : (
//           <button
//             className="btn btn-next"
//             onClick={handleNext}
//             disabled={!selectedAnswer}
//           >
//             Next
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PracticeExam;
